namespace JupitersChoice {
    export class ResetFreeGameReelCrumblesCmd {

        @inject('ComponentManager') _componentManager: Sapphire.ComponentManager;

        execute(): void {
            for (let i = 0; i <= 5; i++) {
                this._componentManager.get(`FreeGameReelCrumbleIntro${i}`).reset();
                this._componentManager.get(`FreeGameReelCrumbleLoop${i}`).reset();

                this._componentManager.get(`FreeGameReelCrumbleIntro${i}`).hide();
                this._componentManager.get(`FreeGameReelCrumbleLoop${i}`).hide();
            }
        }
    }
}